import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function ListEye({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M8 4L9.3 2.375C9.49 2.135 9.77 2 10.08 2H13.91C14.21 2 14.5 2.13 14.69 2.375L15.98 4V5C15.98 5.55 15.53 6 14.98 6H8.98C8.42 6 7.98 5.55 7.98 5V4H8ZM8 4H6C4.89 4 4 4.89 4 6V19C4 20.1 4.89 21 6 21H12M20 12V6C20 4.89 19.1 4 18 4H16M18.379 17.901C18.429 17.951 18.429 18.041 18.379 18.101C18.319 18.151 18.229 18.151 18.169 18.101C18.109 18.041 18.109 17.951 18.169 17.891C18.219 17.831 18.309 17.831 18.369 17.891M8 13.5H13M8 10H16M8 17H10M14.76 18.69C14.48 18.27 14.48 17.72 14.76 17.31C15.6 16.02 16.94 14.99 18.273 14.99C19.603 14.99 20.933 16.01 21.783 17.3C22.053 17.71 22.053 18.26 21.783 18.68C20.933 19.962 19.593 20.99 18.263 20.99C16.923 20.99 15.593 19.96 14.75 18.68L14.76 18.69Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default ListEye;